import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const SKELETON_PULSE_DURATION = "1.5s";

export const useAdminSidebarStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "280px",
    minWidth: "280px",
    height: "100dvh",
    backgroundColor: designTokens.neutral.white,
    borderRight: `1px solid ${designTokens.neutral[200]}`,
    boxSizing: "border-box",
  },

  header: {
    ...shorthands.padding(designTokens.spacing[6]),
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
  },

  headerTitle: {
    fontSize: designTokens.fontSize.xl,
    fontWeight: designTokens.fontWeight.semibold,
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[900],
    marginTop: "0",
    marginBottom: designTokens.spacing[1],
  },

  headerSubtitle: {
    fontSize: designTokens.fontSize.sm,
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[500],
    marginTop: "0",
    marginBottom: "0",
  },

  scrollContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    flexGrow: 1,
    ...shorthands.padding(designTokens.spacing[4]),
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: designTokens.neutral[300],
      borderRadius: designTokens.borderRadius.full,
    },
  },

  groupContainer: {
    marginBottom: designTokens.spacing[6],
  },

  groupHeader: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[400],
    textTransform: "uppercase",
    letterSpacing: designTokens.letterSpacing.wide,
    ...shorthands.padding(designTokens.spacing[2], designTokens.spacing[3]),
    marginBottom: designTokens.spacing[1],
  },

  navItem: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    ...shorthands.padding(designTokens.spacing[3]),
    ...shorthands.gap(designTokens.spacing[3]),
    ...shorthands.border("0"),
    backgroundColor: "transparent",
    cursor: "pointer",
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    fontFamily: designTokens.fontFamily,
    transitionProperty: "background-color, color",
    transitionDuration: designTokens.transition.fast,
    "&:hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.neutral[900],
    },
    "&:focus-visible": {
      outlineWidth: "2px",
      outlineStyle: "solid",
      outlineColor: designTokens.neutral[900],
      outlineOffset: "2px",
    },
  },

  navItemSelected: {
    backgroundColor: designTokens.accent[50],
    color: designTokens.accent[600],
  },

  navItemIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "20px",
    height: "20px",
    color: designTokens.neutral[600],
    flexShrink: 0,
  },

  navItemIconSelected: {
    color: designTokens.accent[600],
  },

  navItemLabel: {
    flexGrow: 1,
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.medium,
    color: designTokens.neutral[600],
    textAlign: "left",
  },

  navItemLabelSelected: {
    color: designTokens.accent[600],
  },

  badge: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    fontFamily: designTokens.fontFamily,
    color: designTokens.neutral[600],
    backgroundColor: designTokens.neutral[200],
    ...shorthands.padding("2px", designTokens.spacing[2]),
    ...shorthands.borderRadius(designTokens.borderRadius.full),
    minWidth: "20px",
    textAlign: "center",
  },

  badgeSelected: {
    backgroundColor: designTokens.accent[100],
    color: designTokens.accent[600],
  },

  badgeLoading: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    minWidth: "20px",
    ...shorthands.padding("2px", designTokens.spacing[2]),
    ...shorthands.borderRadius(designTokens.borderRadius.full),
    backgroundColor: designTokens.neutral[200],
    textAlign: "center",
    color: "transparent",
    animationName: {
      "0%": { opacity: 0.4 },
      "50%": { opacity: 1 },
      "100%": { opacity: 0.4 },
    },
    animationDuration: SKELETON_PULSE_DURATION,
    animationIterationCount: "infinite",
    "@media screen and (prefers-reduced-motion: reduce)": {
      animationIterationCount: "1",
    },
  },
});
